class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);
if (!customElements.get('cart-items')) {
  customElements.define('cart-items', class CartItems extends HTMLElement {
    cartUpdateUnsubscriber = undefined;
    
    constructor() {
      super();

      this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
      this.cartErrors = document.getElementById('cart-errors');

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }

    onCartUpdate(event) {
      const sections = event.sections; 
      const parsedState = event.cart || event.cartData; 
            if (!parsedState) return;
      
      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (parsedState.errors) {
        this.updateErrorLiveRegions(event.line, parsedState.errors);
      }
      this.getSectionsToRender().forEach((section => {
        const element = document.getElementById(section.id);
        
        if (element) {
          const elementToReplace = element.querySelector(section.selector) || element;
          if (elementToReplace && parsedState.sections[section.section]) {
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }
      }));
      
      this.updateQuantityLiveRegions(event.line, parsedState.item_count);
      
      const lineItem = document.getElementById(`CartItem-${event.line}`);
      if (lineItem && event.name) lineItem.querySelector(`[name="${event.name}"]`).focus();
      this.disableLoading();

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {
          cart: parsedState
        }
      }));
    }

    updateQuantity(line, quantity, name, target) {
      const sections = this.getSectionsToRender().map((section) => section.section);
      const body = JSON.stringify({
        line,
        quantity,
        sections: sections,
        sections_url: window.location.pathname
      });

      fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cart: parsedState,  target, line, name, sections  });
        })
        .catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          this.disableLoading();
          if (this.cartErrors) {
            this.cartErrors.textContent = theme.cartStrings.error;
          }
        });
    }

    onChange(event) {
      if (event.target === null) return;
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    getSectionsToRender() {
      let sections = [
        {
          id: 'mini-cart',
          section: document.getElementById('mini-cart')?.id,
          selector: '.shopify-section',
        },
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items')?.dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'mobile-cart-icon-bubble',
          section: 'mobile-cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer')?.dataset.id,
          selector: '.js-contents',
        }
      ];
      if (document.querySelector('#main-cart-footer .free-shipping')) {
        sections.push({
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer')?.dataset.id,
          selector: '.free-shipping',
        });
      }
      return sections;
    }

    updateErrorLiveRegions(line, message) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
    
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    
      const cartStatus =
        document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
      cartStatus.setAttribute('aria-hidden', false);
    
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
    
    updateQuantityLiveRegions(line, itemCount) {
      if (this.currentItemCount === itemCount) {
        const quantityError = document.getElementById(`Line-item-error-${line}`);
        if (quantityError) {
          quantityError.querySelector('.cart-item__error-text')
            .innerHTML = theme.cartStrings.quantityError.replace(
              '[quantity]',
              document.getElementById(`Quantity-${line}`).value
            ); 
        }
      }

      this.currentItemCount = itemCount;
      
      if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

      const cartStatus = document.getElementById('cart-live-region-text');
      if (cartStatus) {
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
          cartStatus.setAttribute('aria-hidden', true);
        }, 1e3);
      }
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }

    enableLoading(line) {
      const cartItems = document.getElementById('main-cart-items');
      if (cartItems) cartItems.classList.add('cart__items--disabled');

      const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
      if (loadingOverlay) loadingOverlay.classList.remove('hidden');
      
      document.activeElement.blur();
      if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
      const cartItems = document.getElementById('main-cart-items');
      if (cartItems) cartItems.classList.remove('cart__items--disabled');
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        const element = document.getElementById(section.id);

        if (element) {
          element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      }));
    }
  });
}

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('cart-note', CartNote);

if (!customElements.get('cart-discount')) {
  customElements.define('cart-discount', class CartDiscount extends HTMLElement {
    constructor() {
      super();
      this.onApplyDiscount = this.applyDiscount.bind(this);
    }

    get sectionId() {
      return this.getAttribute('data-section-id');
    }
    
    connectedCallback() {
      this.submitButton = this.querySelector('[data-discount-btn]');
      this.resultsElement = this.lastElementChild;
      this.submitButton.addEventListener('click', this.onApplyDiscount);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.submitButton.removeEventListener('click', this.onApplyDiscount);
    }

    getSectionsToRender() {
      let sections = [
        {
          id: 'mini-cart',
          section: document.getElementById('mini-cart')?.id,
          selector: '.shopify-section',
        },
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items')?.dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'mobile-cart-icon-bubble',
          section: 'mobile-cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer')?.dataset.id,
          selector: '.js-contents',
        }
      ];
      if (document.querySelector('#main-cart-footer .free-shipping')) {
        sections.push({
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer')?.dataset.id,
          selector: '.free-shipping',
        });
      }
      return sections;
    }

    applyDiscount(event) {
      event.preventDefault();

      const discountCode = this.querySelector('[name="discount"]');
      if (!(discountCode instanceof HTMLInputElement) || typeof this.getAttribute('data-section-id') !== 'string') return;

      this.abortController?.abort();
      this.abortController = new AbortController();

      const discountCodeValue = discountCode.value.trim();
      if (discountCodeValue === '') return;

      const existingDiscounts = this.existingDiscounts();
      if (existingDiscounts.includes(discountCodeValue)) return;

      this.setDiscountError('');
      this.submitButton.setAttribute('aria-busy', 'true');
      
      const sections = this.getSectionsToRender().map((section) => section.section);
      const body = JSON.stringify({
        discount: [...existingDiscounts, discountCodeValue].join(','),
        sections: sections,
        sections_url: window.location.pathname
      });

      fetch(`${theme.routes.cart_update_url}`, {...fetchConfig('json'), ...{ body }, signal: this.abortController.signal })
        .then((response) => response.json())
        .then((parsedState) => {
          if (
            parsedState.discount_codes.find((discount) => {
              return discount.code === discountCodeValue && discount.applicable === false;
            })
          ) {
            discountCode.value = '';
            this.setDiscountError(theme.discountStrings.error);
            return;
          }
          
          const newHtml = parsedState.sections[this.sectionId];
          const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
          const section = parsedHtml.getElementById(`shopify-section-${this.sectionId}`);

          if (section) {
            const discountCodes = section?.querySelectorAll('button[is="discount-remove"]') || [];
            const codes = Array.from(discountCodes)
              .map((element) => (element instanceof HTMLButtonElement ? element.getAttribute('data-discount') : null))
              .filter(Boolean);

            if (
              codes.length === existingDiscounts.length &&
              codes.every((code) => existingDiscounts.includes(code)) &&
              parsedState.discount_codes.find((discount) => {
                return discount.code === discountCodeValue && discount.applicable === true;
              })
            ) {
              discountCode.value = '';
              this.setDiscountError(theme.discountStrings.shippingError);
              return;
            }
          }

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cart: parsedState });
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          }
          else {
            console.error(error);
          }
        })
        .finally(() => {
          this.submitButton.removeAttribute('aria-busy');
        });
    }

    removeDiscount(event) {
      if ((event instanceof KeyboardEvent && event.key !== 'Enter') || !(event instanceof MouseEvent)) {
        return;
      }

      const discountCode = event.currentTarget.getAttribute('data-discount');
      
      if (!discountCode) return;

      const existingDiscounts = this.existingDiscounts();
      const index = existingDiscounts.indexOf(discountCode);
      if (index === -1) return;

      existingDiscounts.splice(index, 1);

      this.abortController?.abort();
      this.abortController = new AbortController();

      this.setDiscountError('');
      event.currentTarget.setAttribute('loading', '');

      const sections = this.getSectionsToRender().map((section) => section.section);
      const body = JSON.stringify({
        discount: existingDiscounts.join(','),
        sections: sections,
        sections_url: window.location.pathname
      });
      
      fetch(theme.routes.cart_update_url, { ...fetchConfig(), ...{ body }, signal: this.abortController.signal })
        .then((response) => response.json())
        .then((parsedState) => {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cart: parsedState });
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          }
          else {
            console.error(error);
          }
        })
        .finally(() => {
          event.target.removeAttribute('loading');
        });
    }

    existingDiscounts() {
      const discountCodes = [];
      const discountPills = this.querySelectorAll('button[is="discount-remove"]');
      for (const pill of discountPills) {
        if (pill.hasAttribute('data-discount')) {
          discountCodes.push(pill.getAttribute('data-discount'));
        }
      }
      return discountCodes;
    }

    setDiscountError(error) {
      this.resultsElement.lastElementChild.textContent = error;
      if(error.length === 0) {
        this.resultsElement.classList.add('hidden');
      } else {
        this.resultsElement.classList.remove('hidden');
      }
    }
  });
}

class DiscountRemove extends HTMLButtonElement {
  constructor() {
    super();
     this.addEventListener('click', (event) => {
        const cartDiscount = this.closest('cart-discount') || document.querySelector('cart-discount');
        if (cartDiscount) {
          event.preventDefault();
          cartDiscount.removeDiscount(event);
        }
      });
  }
}
customElements.define('discount-remove', DiscountRemove, { extends: 'button' });

// ZIPCODE ranges for Brazilian states
const ZIPCODE_RANGES = [
  { province: 'SP', from: 1000000, to: 19999999 },
  { province: 'RJ', from: 20000000, to: 28999999 },
  { province: 'ES', from: 29000000, to: 29999999 },
  { province: 'MG', from: 30000000, to: 39999999 },
  { province: 'BA', from: 40000000, to: 48999999 },
  { province: 'SE', from: 49000000, to: 49999999 },
  { province: 'PE', from: 50000000, to: 56999999 },
  { province: 'AL', from: 57000000, to: 57999999 },
  { province: 'PB', from: 58000000, to: 58999999 },
  { province: 'RN', from: 59000000, to: 59999999 },
  { province: 'CE', from: 60000000, to: 63999999 },
  { province: 'PI', from: 64000000, to: 64999999 },
  { province: 'MA', from: 65000000, to: 65999999 },
  { province: 'PA', from: 66000000, to: 68899999 },
  { province: 'AP', from: 68900000, to: 68999999 },
  { province: 'AM', from: 69000000, to: 69299999 },
  { province: 'RR', from: 69300000, to: 69399999 },
  { province: 'AM', from: 69400000, to: 69899999 },
  { province: 'AC', from: 69900000, to: 69999999 },
  { province: 'DF', from: 70000000, to: 72799999 },
  { province: 'GO', from: 72800000, to: 72999999 },
  { province: 'DF', from: 73000000, to: 73699999 },
  { province: 'GO', from: 73700000, to: 76799999 },
  { province: 'RO', from: 76800000, to: 76999999 },
  { province: 'TO', from: 77000000, to: 77999999 },
  { province: 'MT', from: 78000000, to: 78899999 },
  { province: 'MS', from: 79000000, to: 79999999 },
  { province: 'PR', from: 80000000, to: 87999999 },
  { province: 'SC', from: 88000000, to: 89999999 },
  { province: 'RS', from: 90000000, to: 99999999 }
];

function getZipcodeProvince(zipcode) {
  let province = '';
  try {
    const zip = parseInt(zipcode.replace('-', ''));
    for (const range of ZIPCODE_RANGES) {
      if (zip >= range.from && zip <= range.to) {
        province = range.province;
        break;
      }
    }
  } catch (e) {
    console.log(e);
  }
  return province;
}

function convertDeliveryDate(date) {
  let formattedDate = '';
  if (date && date.length > 0) {
    try {
      const deliveryDate = new Date(date);
      const nextDay = new Date(deliveryDate.getTime() + 86400000);
      const day = nextDay.getDate();
      const month = nextDay.getMonth() + 1;
      formattedDate = `${day > 9 ? day : `0${day}`}/${month > 9 ? month : `0${month}`}`;
    } catch (e) {
      // Handle error silently
    }
  }
  return formattedDate;
}

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    // Find all state elements
    this.wrapper = this.closest('.shipping-calculator-wrapper') || document.querySelector('.shipping-calculator-wrapper');
    this.buttonInitial = this.wrapper ? this.wrapper.querySelector('.shipping__calculator-button-initial') : null;
    this.formState = this.wrapper ? this.wrapper.querySelector('.shipping__calculator-form') : null;
    this.resultState = this.wrapper ? this.wrapper.querySelector('.shipping__calculator-result') : null;
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.wrapper ? this.wrapper.querySelector('#ShippingCalculatorSuccess') : null;
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.button = this.querySelector('.button--calculate');
    this.closeButton = this.wrapper ? this.wrapper.querySelector('.shipping__calculator-close') : null;
    this.typeReturn = this.getAttribute('data-type-return') || 'option1';
    
    if (this.button) {
      this.button.addEventListener('click', this.onSubmitHandler.bind(this));
    }
    
    if (this.zip) {
      this.zip.addEventListener('input', this.inputMask.bind(this));
    }
    
    if (this.buttonInitial) {
      const initialButton = this.buttonInitial.querySelector('button');
      if (initialButton) {
        initialButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.showFormState();
        });
      }
    }
    
    if (this.closeButton) {
      this.closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.showInitialState();
      });
    }
    
    this.init();
  }

  init() {
    const savedData = this.getLocalStorageCupom();
    
    if (savedData && savedData.html && savedData.html !== '') {
      // Show result state
      this.showResultState(savedData.html);
      if (this.zip) {
        this.zip.value = savedData.zipcode;
      }
    } else {
      // Show initial state
      this.showInitialState();
    }
  }

  showInitialState() {
    if (this.buttonInitial) this.buttonInitial.classList.remove('hidden');
    if (this.formState) this.formState.classList.add('hidden');
    if (this.resultState) this.resultState.classList.add('hidden');
  }

  showFormState() {
    if (this.buttonInitial) this.buttonInitial.classList.add('hidden');
    if (this.formState) this.formState.classList.remove('hidden');
    if (this.resultState) this.resultState.classList.add('hidden');
    if (this.zip) {
      this.zip.focus();
    }
  }

  showResultState(html) {
    // Re-query from wrapper in case DOM was updated (e.g. cart drawer re-render)
    const wrapper = this.wrapper || this.closest('.shipping-calculator-wrapper') || document.querySelector('.shipping-calculator-wrapper');
    const resultState = wrapper ? wrapper.querySelector('.shipping__calculator-result') : this.resultState;
    const successEl = wrapper ? wrapper.querySelector('#ShippingCalculatorSuccess') : this.success;
    if (this.buttonInitial) this.buttonInitial.classList.add('hidden');
    if (this.formState) this.formState.classList.add('hidden');
    if (resultState) {
      resultState.classList.remove('hidden');
      if (successEl) {
        successEl.classList.remove('hidden');
        successEl.innerHTML = html;
      }
      const resultLabel = wrapper ? wrapper.querySelector('.shipping__calculator-result-label') : null;
      if (resultLabel) {
        const newLabel = resultLabel.cloneNode(true);
        resultLabel.parentNode.replaceChild(newLabel, resultLabel);
        newLabel.style.cursor = 'pointer';
        newLabel.addEventListener('click', () => {
          this.showFormState();
        });
      }
    }
  }

  setLocalStorageCupom(html, zipcode) {
    localStorage.setItem('aura:shipping:html', JSON.stringify({ html, zipcode }));
  }

  getLocalStorageCupom() {
    const data = localStorage.getItem('aura:shipping:html');
    return data ? JSON.parse(data) : null;
  }

  inputMask(event) {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 8) {
      value = value.slice(0, 8);
    }
    if (value.length > 5) {
      value = value.replace(/^(\d{5})(\d)/, '$1-$2');
    }
    event.target.value = value;
  }

  async simulateCartWithProduct(variantId, quantity = 1) {
    try {
      const cartResponse = await fetch('/cart.js').then(r => r.json());
      if (cartResponse.items.length > 0) return;
      
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] })
      });
      
      if (!addResponse.ok) return;
      
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.button.click();
      
      const updatedCart = await fetch('/cart.js').then(r => r.json());
      const item = updatedCart.items.find(i => i.variant_id === variantId);
      if (!item) return;
      
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    } catch (e) {
      console.error('Erro na simulação do carrinho:', e);
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    // Re-query elements in case they weren't found initially
    if (!this.success) {
      this.success = this.querySelector('#ShippingCalculatorSuccess') || document.querySelector('#ShippingCalculatorSuccess');
    }
    if (!this.errors) {
      this.errors = this.querySelector('#ShippingCalculatorErrors');
    }
    if (!this.zip) {
      this.zip = this.querySelector('#ShippingCalculatorZip');
    }
    
    if (this.errors) this.errors.classList.add('hidden');
    if (this.zip) this.zip.classList.remove('invalid');
    if (this.button) {
      this.button.classList.add('loading');
      this.button.setAttribute('disabled', '');
    }

    if (!this.zip || !this.zip.value) {
      if (this.errors) {
        this.errors.classList.remove('hidden');
        if (this.errors.querySelector('.errors')) {
          this.errors.querySelector('.errors').innerHTML = 'Por favor, informe um CEP válido';
        }
      }
      if (this.button) {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      }
      return;
    }

    const province = getZipcodeProvince(this.zip.value);
    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value.replace('-', ''),
        country: 'Brazil',
        province: province
      }
    });
    
    let sectionUrl = `${theme.routes.cart_url}/shipping_rates.json`;
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates && parsedState.shipping_rates.length > 0) {
          const rate = parsedState.shipping_rates[0];
          const price = rate.price;
          
          // Format price - always show as currency
          let formattedPrice = price;
          if (typeof price === 'number') {
            formattedPrice = (price / 100).toFixed(2).replace('.', ',');
          } else if (typeof price === 'string') {
            formattedPrice = parseFloat(price).toFixed(2).replace('.', ',');
          }
          const priceText = `R$ ${formattedPrice}`;
          
          // Format delivery date
          const deliveryDate = convertDeliveryDate(rate.delivery_date);
          const deliveryText = this.typeReturn === 'option2' 
            ? `Prazo de entrega: ${deliveryDate}` 
            : `Chega até ${deliveryDate}`;
          
          // Create HTML for result
          const resultHTML = `
            <p>${rate.name}: ${priceText}</p>
            <p>${deliveryText}</p>
          `;
          
          // Show result state
          this.showResultState(resultHTML);
          this.setLocalStorageCupom(resultHTML, this.zip.value);
        } else {
          let errors = [];
          Object.entries(parsedState).forEach(([key, value]) => {
            if (key === 'zip') {
              errors.push(`${value[0]}`);
            } else if (key === 'province') {
              errors.push('CEP inválido');
            }
          });
          
          if (errors.length === 0) {
            errors.push('Não foi possível calcular o frete. Verifique o CEP e tente novamente.');
          }
          
          this.setLocalStorageCupom('', '');
          if (this.errors) {
            this.errors.classList.remove('hidden');
            if (this.errors.querySelector('.errors')) {
              this.errors.querySelector('.errors').innerHTML = errors.join('; ');
            }
          }
        }
      })
      .catch((e) => {
        if (this.isPDP) {
          this.simulateCartWithProduct(this.pdpVariantId);
        }
        console.error('Erro ao calcular frete:', e);
        if (this.errors) {
          this.errors.classList.remove('hidden');
          if (this.errors.querySelector('.errors')) {
            this.errors.querySelector('.errors').innerHTML = 'Erro ao calcular frete. Tente novamente.';
          }
        }
      })
      .finally(() => {
        if (this.button) {
          this.button.classList.remove('loading');
          this.button.removeAttribute('disabled');
        }
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);
